import React, { useEffect, useState } from "react";
import { useSearchParams, useLocation } from "react-router-dom";
import "./styles/Completion.css";
import Header from "../components/Header";

const Completion = () => {
    const [sessionData, setSessionData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const location = useLocation();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const newSessionId = searchParams.get("session_id");

        if (newSessionId) {

            const fetchSessionData = async () => {
                try {
                    const response = await fetch(`https://bunny-klawz.uc.r.appspot.com/payment-status/${newSessionId}`);
                    if (!response.ok) throw new Error("Failed to fetch session data");
                    const data = await response.json();
                    setSessionData(data);
                } catch (err) {
                    setError(err.message);
                } finally {
                    setLoading(false);
                }
            };

            fetchSessionData();

        } else {
            setError("No session_id provided");
            setLoading(false);
            return;
        }
    }, [location.search]); // Runs only when `location.search` changes

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;

    return (
        <>
            {/* <Header /> */}
            <div className={`home-page darken fade`}>

                <>
                    <div className={`fade-in show`}>
                        <div className="booking-container centerThis">
                            {/* <div className="booking-header">
                                <h2>Booking an Appointment</h2>
                                <p>
                                    Please click{" "}
                                    <a
                                        href="https://www.instagram.com/bunnyklawz"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        here
                                    </a>{" "}
                                    to DM @bunnyklawz on Instagram for any questions!
                                </p>
                            </div> */}
                            <>
                                <div className="questions calendar-page fade shrinkThis">
                                    {/* Preferred Nail Tech Selection */}
                                    <div>
                                        <div>
                                            {/* <h3 className="payment-confirmation-instagram">@{instagram}</h3> */}
                                            <h1 className="payment-confirmation-message">Your appointment request has been sent. Please give us 24 hours to confirm your deposit and appointment. <br /> Thank you so much!</h1>
                                        </div>
                                    </div>
                                </div>
                            </>
                            <a href="https://bunnyklawz.com/" className="completion-return">
                                Return to Booking
                            </a>
                        </div>
                    </div>
                </>
            </div>
        </>
    );
};

export default Completion;